import { CustomExtender } from '#/CoreFrameInterfaces';
import Async from '@/Infrastructure/CustomExtenders/AsyncExtender';
import Overwritable from '@/Infrastructure/CustomExtenders/OverwritableExtender';
import Publisher from '@/Infrastructure/CustomExtenders/PublisherExtender';
import TrackChange from '@/Infrastructure/CustomExtenders/TrackChangeExtender';
import Waiter from '@/Infrastructure/CustomExtenders/WaiterExtender';

export default function init() {
    let customExtenders: CustomExtender[] = [
        new Async(),
        new Overwritable(),
        new Publisher(),
        new TrackChange(),
        new Waiter()
    ];

    customExtenders.forEach(extender => extender.AddToKnockout());
}